import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  ButtonGroup,
  Checkbox,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import HeaderBlock from "../../../components/header-block/HeaderBlock";

import { getActivityById } from "../../../state/actions/MyDisplaysActions";
import {
  getRewardById,
  updateReward,
} from "../../../state/actions/ActivityActions";
import { Loading } from "../../../components/loading/Loading";

const RewardPage = (props) => {
  const dispatch = useDispatch();
  const displayGroupId = props.match.params.DisplayGroupId;
  const displayIndex = props.match.params.DisplayIndex;
  const activityId = props.match.params.ActivityId;
  const rewardRange = props.match.params.RewardId;

  const currentActivity = useSelector(
    (state) => state.MyDisplaysReducer.displayActivity
  );

  const currentReward = useSelector(
    (state) => state.ActivityReducer.currentReward
  );

  const loggedInUser = useSelector((state) => state.UserReducer.loggedInUser);

  let createdUser = "";
  if (typeof loggedInUser.userName !== "undefined") {
    createdUser = loggedInUser.userName.split("\\")[1];
  }

  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [existingReward, setExistingReward] = useState({});

  useEffect(() => {
    dispatch(getActivityById(activityId, () => {}));
  }, []);

  useEffect(() => {
    dispatch(
      getRewardById(activityId, rewardRange, () => {
        setLoading(true);
      })
    );
  }, [currentActivity]);

  useEffect(() => {
    setExistingReward(currentReward);
  }, [currentReward]);

  const handleUpperRangeChange = (e) => {
    let localReward = { ...existingReward };
    localReward.upperRange = parseInt(e.target.value);
    setExistingReward(localReward);
  };

  const handleValueChange = (e) => {
    let localReward = { ...existingReward };
    localReward.value = e.target.value;
    setExistingReward(localReward);
  };

  const handleActiveChange = (e) => {
    let localReward = { ...existingReward };
    localReward.active = e.target.checked;
    setExistingReward(localReward);
  };

  const createRequestBody = () => {
    const requestBody = {
      ActivityId: activityId,
      IsActive: existingReward.active,
      ModifiedBy: createdUser,
      UpperRange: existingReward.upperRange,
      Value: existingReward.value,
    };

    return requestBody;
  };

  const submitReward = () => {
    dispatch(
      updateReward(
        activityId,
        currentReward.upperRange,
        createRequestBody(),
        () => {
          props.history.push(
            `/my-displays-maintenance/${displayGroupId}/${displayIndex}/${activityId}`
          );
        }
      )
    );
  };

  const buttonGroupElement = isEditing ? (
    <ButtonGroup style={{ marginRight: "35px" }}>
      <Button
        variant="outlined"
        color="primary"
        onClick={() => setIsEditing(false)}
      >
        Cancel
      </Button>
      <Button variant="outlined" color="secondary" onClick={submitReward}>
        Save
      </Button>
    </ButtonGroup>
  ) : (
    <ButtonGroup>
      <Button
        variant="outlined"
        color="primary"
        onClick={() =>
          props.history.push(
            `/my-displays-maintenance/${displayGroupId}/${displayIndex}/${activityId}`
          )
        }
      >
        Cancel
      </Button>
      <Button
        style={{ marginRight: "35px" }}
        variant="outlined"
        color="secondary"
        onClick={() => setIsEditing(true)}
      >
        Edit
      </Button>
    </ButtonGroup>
  );

  return (
    <div>
      {loading ? (
        <>
          {" "}
          <HeaderBlock
            title={`${currentActivity.Activity.Name} - ${existingReward.upperRange}`}
            right={
              <Grid
                container
                spacing={3}
                alignItems="center"
                justify="flex-end"
              >
                {buttonGroupElement}
              </Grid>
            }
          />
          <div className="create-container" style={{ marginTop: "150px" }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  margin="normal"
                  fullWidth
                  variant="outlined"
                  type="number"
                  label={"Upper Range"}
                  value={existingReward.upperRange}
                  InputLabelProps={{ shrink: true }}
                  disabled={!isEditing}
                  onChange={handleUpperRangeChange}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  margin="normal"
                  fullWidth
                  variant="outlined"
                  type="number"
                  label={"Value"}
                  placeholder="Enter Value"
                  value={existingReward.value}
                  InputLabelProps={{ shrink: true }}
                  disabled={!isEditing}
                  onChange={handleValueChange}
                />
              </Grid>
            </Grid>
            <Grid container spacing={0}>
              <Grid
                item
                xs={6}
                style={{ display: "flex", alignItems: "center" }}
              >
                <Typography>Active</Typography>
                <Checkbox
                  color="primary"
                  disabled={!isEditing}
                  checked={existingReward.active}
                  onChange={handleActiveChange}
                />
              </Grid>
            </Grid>
          </div>
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
};

const hoc = withRouter(RewardPage);

// EXPORT COMPONENT
export { hoc as RewardPage };
